import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchCombiOpdracht } from '../services/fetchCombiOpdracht'

export { useCombiOpdracht }

const queryKey = 'combiopdracht'

const useCombiOpdracht = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
  } = useQuery({
    queryFn: () => fetchCombiOpdracht(id),
    queryKey: [queryKey, id],
    enabled: hasPermissions && !!id,
  })

  return {
    data,
    isLoading,
    isError,
  }
}
